/*  THE BANK'S PLAYER: one preset at a time, centred, the way a single product is shown.

    IT OWNS NO AUDIO. Every preset is rendered as a real player row inside the panel and
    hidden, so ev-kit-audio.js binds them exactly as it binds a folder's rows and knows
    nothing about this control. Pressing play here clicks the current row. The alternative,
    a control that forwards to its own audio code, would have meant a second copy of the
    play, loop, seek and stop logic living out here, and two of them drift.

    THE ARROWS STOP, THEY DO NOT START. Stepping cuts whatever is playing and leaves the
    new preset waiting to be pressed. Apple's own next button keeps playing, and this
    deliberately does not, because Carlos asked for exactly this behaviour on the control
    this one replaces: somebody browsing eight names should not be made to hear all eight.
    Cutting the outgoing preset still matters, because audio continuing under the name of
    a different preset is worse than silence. To flip it to the Apple behaviour, pass true
    as the second argument of step() from the arrow handlers and nothing else changes.

    THE NAME CROSS FADES rather than swapping. At this size a hard cut reads as a glitch,
    and the fade is what tells you the change came from you.

    THE RESTING WAVEFORM IS REPAINTED THROUGH THE PLAYER, not redrawn here. The panel
    exposes its own select() as panel.evKitSelect so that stepping can change which shape
    is on screen without starting a sound. Drawing it a second time in this file would put
    two different pieces of code in charge of one canvas.

    DURATIONS COME FROM ev-dur.js and fall back to the decoded buffer. See the note there.

    IT DOES NOTHING ON A PAGE WITHOUT THE MARKUP.  */
(function () {
  'use strict';

  function stem (s) { return s.split('/').pop().split('?')[0].replace(/\.[A-Za-z0-9]+$/, ''); }
  function ms (t) {
    if (!t && t !== 0) return '0:00';
    return Math.floor(t / 60) + ':' + String(Math.floor(t % 60)).padStart(2, '0');
  }

  document.querySelectorAll('[data-ev-now]').forEach(function (now) {
    var rows = [].slice.call(now.querySelectorAll('[data-ev-track]'));
    if (!rows.length) return;

    var name = now.querySelector('[data-ev-now-name]');
    var kind = now.querySelector('[data-ev-now-kind]');
    var tEl  = now.querySelector('[data-ev-now-t]');
    var dEl  = now.querySelector('[data-ev-now-d]');
    var go   = now.querySelector('[data-ev-now-go]');
    var prev = now.querySelector('[data-ev-now-prev]');
    var next = now.querySelector('[data-ev-now-next]');
    var dots = now.querySelector('[data-ev-now-dots]');

    var i = 0, fading = 0;

    function durOf (r) {
      var d = (window.EV_DUR || {})[stem(r.getAttribute('data-ev-track'))];
      return d || 0;
    }

    /*  one dot per preset, and each is a real jump rather than decoration  */
    if (dots && rows.length > 1) {
      rows.forEach(function (r, k) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'ev-nw-dot';
        d.setAttribute('aria-label', r.getAttribute('data-name') || ('Preset ' + (k + 1)));
        d.addEventListener('click', function () { step(k); });
        dots.appendChild(d);
      });
    }
    var dotEls = dots ? [].slice.call(dots.children) : [];

    function step (n, andPlay) {
      /*  clicking a playing row is the player's own stop, so the outgoing preset is cut
          through the same path a second press on it would take  */
      var wasOn = rows[i].classList.contains('is-on');
      if (wasOn) rows[i].click();

      i = (n + rows.length) % rows.length;
      var r = rows[i];

      if (name) {
        name.classList.add('is-out');
        clearTimeout(fading);
        fading = setTimeout(function () {
          name.textContent = r.getAttribute('data-name') || '';
          if (kind) kind.textContent = r.getAttribute('data-kind') || '';
          name.classList.remove('is-out');
        }, 150);
      }

      if (tEl) tEl.textContent = '0:00';
      if (dEl) dEl.textContent = ms(durOf(r));
      dotEls.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });

      /*  repaint the resting shape without making a sound  */
      if (typeof now.evKitSelect === 'function') now.evKitSelect(r, false);
      if (andPlay) r.click();
    }

    if (prev) prev.addEventListener('click', function () { step(i - 1); });
    if (next) next.addEventListener('click', function () { step(i + 1); });
    if (go)   go.addEventListener('click', function () { rows[i].click(); });

    now.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  step(i - 1);
      if (e.key === 'ArrowRight') step(i + 1);
    });

    if (rows.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    function frame () {
      requestAnimationFrame(frame);
      var s = window.evKitAudio && window.evKitAudio.state && window.evKitAudio.state();
      var on = !!(s && s.row === rows[i]);
      if (go) go.classList.toggle('is-on', on);
      if (on) {
        if (tEl) tEl.textContent = ms(s.t);
        if (dEl) dEl.textContent = ms(s.duration);
      }
    }

    step(0);
    requestAnimationFrame(frame);
  });
})();